import { Injectable } from '@angular/core';
import { ChangeTyped, SearchResult } from '@damofire/data-commons';
import { Observable } from 'rxjs';
import { TypedDesQuery } from '../des.dto';
import { Repair } from './repair.dto';

@Injectable()
export abstract class ObservableRepairService {
  protected readonly SEARCH_FIELDS = ['number', 'description', 'productInstalled', 'upright.description'];

  abstract observeByAsset(divisionId: string, assetId: string): Observable<ChangeTyped<Repair>[]>;
  abstract observeByWarehouse(id: string): Observable<ChangeTyped<Repair>[]>;
  abstract observeById(division: string, id: string): Observable<ChangeTyped<Repair>>;
  abstract search(divisionId: string, sQuery: TypedDesQuery): Observable<SearchResult<Repair>>;
}
